import { formatDate } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { Niveis } from '../../_models/Enums/niveis';
import filtroExtrato from '../../_models/filtroExtrato';
import { Configuracao } from '../../_models/configuracao.model';


@Component({
  selector: 'app-extrato',
  templateUrl: './extrato.component.html',
  styleUrls: ['./extrato.component.scss'],
})
export class ExtratoComponent implements OnInit {
  public extratoColunas: any[] = [];
  public tiposCategoria: any[] = [];
  public tipoSelecionadoId: number = 1;

  // Tamanho da tela
  public mostrarTexto = true;

  // Extrato
  public extrato: any[] = [];
  public extratoCompleto: any[] = [];
  public novoExtrato: any[] = [];
  public respostaExtrato: any[] = [6];

  // Popups
  public exibirPopupPeriodo: boolean = false;
  public exibirPopup: boolean = false;

  // Carregamentos
  public carregandoMembro: boolean = false;
  public carregandoExtrato: boolean = false;
  public carregandoVencimentos: boolean = false;

  // Periodos
  public periodos: any[] = [];

  public pontosAExpirar: any = undefined;
  public xpAExpirar: any = undefined;

  public membro: any = undefined;

  // Filtros
  public pesquisaForm: UntypedFormGroup;
  public buttonFiltrar: boolean = false;
  public loadingAplicar: boolean = false;
  public textoPesquisa: string = '';
  public periodoSelecionadoIndex: number = 2;
  public categoriaSelecionadoIndex: number = 0;
  public filtroDataInicial: any;
  public filtroDataFinal: any;
  public categoriasLista: any[] = [];
  public periodoSelecionada: any = undefined;
  public ehVencimento: boolean = false;

  public width = window.screen.width;

  public exibirSaldoPontos: boolean;
  public exibirMensagemDeQuantidadeMaximaDeCacaus: boolean = false;
  public valorMaximoCacausPorCupom: number = 0;
  public sizeFonteAviso: 'font-medium' | 'font-small' = 'font-medium';

  constructor(
    private fidelidadeService: FidelidadeService,
    private FormBuilder: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    this.pesquisaForm = this.FormBuilder.group({
      momentoEspecialNome: '',
    });
  }

  ngOnInit(): void {
    this.carregarPeriodos();
    this.obterProximosVencimentos();
    this.carregarMembroLogado();
    this.aplicarFiltro();
    this.obterConfiguracao(Configuracao.VALOR_MAXIMO_CACAUS);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.mostrarTexto = window.innerWidth > 668;
  }

  private obterConfiguracao(descricao: string) {
    this.fidelidadeService.obterConfiguracaoPorDescricao(descricao).subscribe({
      next: (configuracao: Configuracao) => {
        this.exibirMensagemDeQuantidadeMaximaDeCacaus = configuracao.ativo;
        this.valorMaximoCacausPorCupom = configuracao.valorFormatado as number;
        this.sizeFonteAviso = 'font-small';
      },
      error: _ => {
        this.exibirMensagemDeQuantidadeMaximaDeCacaus = false;
        this.sizeFonteAviso = 'font-medium';
      }
    });
  }

  private carregarMembroLogado(): void {
    this.carregandoMembro = true;

    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;
    if (this.membro.tipoStatus === 7 || this.membro.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    }
    this.carregandoMembro = false;
    this.exibirSaldoPontos = res.idNivel != Niveis.Mozao;
  }

  private processarFalhaObterMembro(err: any): void {
    console.error('Ocorreu um erro ao obter o membro', err);
    this.carregandoMembro = false;
  }

  private carregarPeriodos(): void {
    this.periodos = [
      {
        id: 1,
        descricao: '5 dias',
        valor: 5,
        selecionado: false,
      },
      {
        id: 2,
        descricao: '15 dias',
        valor: 15,
        selecionado: false,
      },
      {
        id: 3,
        descricao: '30 dias',
        valor: 30,
        selecionado: true,
      },
      {
        id: 4,
        descricao: '60 dias',
        valor: 60,
        selecionado: false,
      },
      {
        id: 5,
        descricao: 'Total',
        valor: 0,
        selecionado: false,
      },
    ];

    this.tiposCategoria = [
      {
        descricao: 'Compras',
        valor: 1,
        selecionado: false,
      },
      {
        descricao: 'Resgates',
        valor: 2,
        selecionado: false,
      },
      {
        descricao: 'Vencimentos',
        valor: 3,
        selecionado: false,
      },
      {
        descricao: 'Créditos',
        valor: 4,
        selecionado: false,
      },
      {
        descricao: 'Estornos',
        valor: 5,
        selecionado: false,
      },
    ];

    this.extratoColunas = [
      {
        nome: 'Data',
        iconeSrc: 'assets/images/icons/calendario.png',
        centralizado: false,
        exibicaoIds: [1, 2, 3, 4],
      },
      {
        nome: 'Operação',
        iconeSrc: 'assets/images/icons/operacao.png',
        centralizado: false,
        exibicaoIds: [1, 2, 3, 4],
      },
      {
        nome: 'Valor',
        iconeSrc: 'assets/images/icons/card_dinheiro.png',
        centralizado: true,
        exibicaoIds: [1, 2, 3],
      },
      {
        nome: 'Pontos',
        iconeSrc: 'assets/images/icons/experiencia.png',
        centralizado: true,
        exibicaoIds: [1, 2, 3, 4],
      },
      {
        nome: 'Cacaus',
        iconeSrc: 'assets/images/icons/cacau_moeda.png',
        centralizado: true,
        exibicaoIds: [1, 2, 3, 4],
      },
    ];
  }

  public selecionarPeriodo(periodoSelecionado: any) {
    this.periodos.forEach((periodo) => {
      periodo.selecionado = periodo === periodoSelecionado;
    });
  }

  public selecionarTipoCategoria(index: number) {
    this.tiposCategoria[index].selecionado =
      !this.tiposCategoria[index].selecionado;
    this.categoriaSelecionadoIndex = index + 1;
  }

  private obterProximosVencimentos(): void {
    this.carregandoVencimentos = true;

    this.fidelidadeService.obterTransacaoAExpirar().subscribe({
      next: (res: any) => this.processarSucessoTransacaoAExpirar(res),
      error: (err: any) => this.processarFalhaTransacaoAExpirar(err),
    });
  }

  private processarSucessoTransacaoAExpirar(res: any): void {
    this.pontosAExpirar = res[0];
    this.xpAExpirar = res[1];
    this.carregandoVencimentos = false;
  }

  private processarFalhaTransacaoAExpirar(err: any): void {
    console.error('Ocorreu um erro ao obter as transações a expirar', err);
    this.carregandoVencimentos = false;
  }

  public positivoOuNegativo(valor: number): string {
    if (valor > 0) return '+';
    if (valor < 0) return '';
    return '';
  }

  public definirOperacaoIcone(item: any): string {
    let iconeSrc = 'assets/images/icons/';
    let operacao = item.operacao.toLocaleLowerCase().toString();
    let codigoPedido = item.codigoPedido;

    if (operacao.includes('compra')) iconeSrc += 'cartao';
    else if (operacao.includes('resgate')) iconeSrc += 'ticket';
    else if (operacao.includes('estornado')) iconeSrc += 'estorno';
    else if (operacao.includes('vencimento') || operacao.includes('expirado'))
      iconeSrc += 'vencimento';
    else if (operacao.includes('operação não reconhecida'))
      iconeSrc += 'lixeira';
    else if (
      codigoPedido &&
      typeof codigoPedido === 'string' &&
      !/^\d/.test(codigoPedido) &&
      !codigoPedido.startsWith('CS')
    ) {
      iconeSrc += 'plus';
    } else return '';

    iconeSrc += '.png';
    return iconeSrc;
  }

  public iconeEhResgate(operacao: string): boolean {
    operacao = operacao.toLocaleLowerCase();
    return operacao.includes('resgate') || operacao.includes('estornado');
  }

  public abrirPopupFiltroPeriodo(exibir: boolean) {
    this.exibirPopupPeriodo = exibir;
  }

  public abrirPopupFiltros(exibir: boolean) {
    this.exibirPopup = exibir;
  }

  private obterFiltroCategorias(): any {
    const categorias = _.filter(this.tiposCategoria, (categoria: any) => {
      return categoria.selecionado;
    }).map((x) => x.valor);

    if (categorias.length > 0) {
      let cat: any[] = [];
      for (let index = 0; index < categorias.length; index++) {
        const element = categorias[index];
        cat.push(element);
      }

      var valorString = cat.join(',');
      var valorArray = valorString.split(',').map(Number);
      this.ehVencimento = this.verificaSeVencimento(valorArray);
      return valorArray;
    } else {
      return [];
    }
  }

  private obterFiltroPeriodo(): number {
    for (let index = 0; index < this.periodos.length; index++) {
      const periodo = this.periodos[index];
      if (periodo.selecionado) {
        return periodo.valor;
      }
    }
  }

  public limparFiltros(): void {
    this.buttonFiltrar = false;
    this.filtroDataInicial = null;
    this.filtroDataFinal = null;
    for (let categoria of this.tiposCategoria) categoria.selecionado = false;
    for (let periodo of this.periodos) periodo.selecionado = false;
    this.aplicarFiltro();
  }

  public aplicarFiltro(): void {
    this.carregandoExtrato = true;
    this.loadingAplicar = true;
    this.buttonFiltrar = true;
    var filtroExtrato: filtroExtrato = {
      dias: this.obterFiltroPeriodo(),
      dataInicial:
        this.filtroDataInicial != undefined ? this.filtroDataInicial : null,
      dataFinal:
        this.filtroDataFinal != undefined ? this.filtroDataFinal : null,
      filtros: this.obterFiltroCategorias(),
    };
    this.fidelidadeService.obterExtratoPorFiltro(filtroExtrato).subscribe({
      next: (res: any) => {
        this.processarSucessoObterExtratoPorFiltro(res);
        this.exibirPopup = false;
      },
      error: (error: any) => {
        this.exibirPopup = false;
      },
    });
  }

  private processarSucessoObterExtratoPorFiltro(res: any): void {
    this.extrato = [];
    let extratoFinal: any[] = [];
    this.respostaExtrato = res;
    res.forEach((item: any) => {
      let descricao: string = item.descricao.toLocaleLowerCase();
      let operacao: string = '';
      let codigoPedido: string = item.codigoPedido;
      let nomeResgate = item.descricao.split('-');
      if (item.operacao == null) {
        if (descricao === 'pontos') {
          operacao = 'Vencimento de Ponto';
        } else if (descricao === 'cacaus') {
          operacao = 'Vencimento | ' + item.refVenda;
        } else {
          operacao = 'Operação não reconhecida';
        }
      } else {
        if (item.descricao.toLocaleLowerCase() === 'desafio concluído')
          operacao = 'Desafio Concluído';
        else if (item.descricao == '') operacao = `${item.operacao}`;
        else if (
          codigoPedido &&
          typeof codigoPedido === 'string' &&
          !/^\d/.test(codigoPedido) &&
          !codigoPedido.startsWith('CS')
        )
          operacao = `Crédito | ${nomeResgate[0]} ${
            nomeResgate[1] ? '-' + nomeResgate[1] : ''
          }`;
        else if (item.descricao == 'Compra') operacao = 'Compra';
        else if (item.operacao.toLocaleLowerCase() == 'expirado')
          operacao = 'Expirado';
        else
          operacao = `${item.operacao.charAt(0).toUpperCase()}${item.operacao
            .slice(1)
            .toLowerCase()} | ${item.descricao
            .charAt(0)
            .toUpperCase()}${item.descricao.slice(1).toLowerCase()}`;
      }

      if (
        !(
          operacao === 'Vencimento de Cacau' ||
          operacao === 'Vencimento de Ponto' ||
          operacao === 'Resgate | Resgate'
        ) &&
        !(item.status === 'BLOQUEADA' && operacao.startsWith('Vencimento |'))
      ) {
        const itemExtrato: any = {
          data: item.data,
          operacao: operacao.replace('Desafio Concluído', 'Missão concluída'),
          valor: item.valor,
          codigoPedido: item.codigoPedido,
          descricao: item.descricao,
          pontos:
            item.status === 'BLOQUEADA' && item.descricao === 'Compra'
              ? 0
              : !item.operacao
              ? Number('-' + item.pontos.toString())
              : item.pontos,
          cacaus:
            (item.status === 'BLOQUEADA' && item.descricao === 'Compra') ||
            (item.status === 'BLOQUEADA' && item.operacao === 'SALDO')
              ? 0
              : !item.operacao
              ? this.obterValorFormatado(item.cacaus)
              : item.operacao == 'RESGATE' ||
                item.operacao == 'EXPIRADO' ||
                item.operacao == 'ESTORNADO'
              ? item.cacaus
              : item.cacausGerados,
        };
        extratoFinal.push(itemExtrato);
      }
    });
    this.carregandoExtrato = false;
    this.loadingAplicar = false;
    this.extrato = extratoFinal;
  }

  private obterValorFormatado(valor: string): number {
    const valorNumerico = Number(valor);

    if (valorNumerico == 0) return valorNumerico;

    return Number('-' + valorNumerico.toString());
  }

  public obterFiltrosSelecionados(lista: any[]): any[] {
    return lista.filter((x) => x.selecionado);
  }

  public obterFiltrosSelecionadosPeriodo(lista: any[]): any[] {
    const filtrosSelecionados = lista.filter((x) => x.selecionado);

    if (filtrosSelecionados.length > 1) {
      filtrosSelecionados.forEach((filtro, index) => {
        if (index !== filtrosSelecionados.length - 1) {
          filtro.selecionado = false;
        }
      });
    }
    return lista;
  }

  public selecionaPeriodo(periodo: any) {
    if (this.periodoSelecionadoIndex == periodo.id) {
      this.periodoSelecionadoIndex = undefined;
      return periodo.selecionado;
    }
    this.periodoSelecionadoIndex = periodo;
  }

  public desmarcarItem(item: any): void {
    item.selecionado = false;

    this.aplicarFiltro();
  }

  public desmarcarData() {
    if (this.filtroDataInicial != null && this.filtroDataFinal != null) {
      this.filtroDataInicial = null;
      this.filtroDataFinal = null;
    }
    this.aplicarFiltro();
  }

  public verificarSelecionado(arr1: any[], arr2: any[]): boolean {
    let encontrado = false;

    arr1.forEach((obj) => {
      if (obj.selecionado === true) {
        encontrado = true;
        return;
      }
    });

    if (encontrado) {
      return true;
    }

    arr2.forEach((obj) => {
      if (obj.selecionado === true) {
        encontrado = true;
        return;
      }
    });

    return encontrado;
  }

  public formatarDataInicialEFinal(dataInicial: Date, dataFinal: Date): string {
    const dataInicialFormatada = formatDate(dataInicial, 'dd/MM/yyyy', 'pt-BR');
    const dataFinalFormatada = formatDate(dataFinal, 'dd/MM/yyyy', 'pt-BR');
    for (let periodo of this.periodos) periodo.selecionado = false;
    return `${dataInicialFormatada}--${dataFinalFormatada}`;
  }

  public verificaSeVencimento(array) {
    return array.includes(3);
  }
}
